import NotAuthorizedComp from './NotAuthorized'
import NotFoundComp from './NotFound'
import ServiceUnavailableComp from './ServiceUnavailable'

const meta = {
	title: 'Views/ErrorPages',
	component: ServiceUnavailableComp,
}
export default meta

export function ServiceUnavailable() {
	return <ServiceUnavailableComp />
}
export function NotFound() {
	return <NotFoundComp />
}

export function NotAuthorized() {
	return <NotAuthorizedComp />
}
